import { MantineColor, MantineSize } from '@mantine/core';
import { type Position } from 'react-tippy';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';
import Icon from '../Icon/Icon';

type InformationIconProps = {
	text: string;
	className?: string;
	size?: MantineSize | number;
	color?: MantineColor | string;
	tooltipPosition?: Position;
	tooltipDisabled?: boolean;
};

const InformationIcon = ( {
	text,
	className,
	color = 'primary',
	size = 16,
	tooltipPosition = 'top',
	tooltipDisabled = false
}: InformationIconProps ) => (
	<Tooltip
		className={className}
		title={text}
		position={tooltipPosition}
		disabled={tooltipDisabled}
	>
		<Icon
			icon="info_outlined"
			size={size}
			color={color}
		/>
	</Tooltip>
);
InformationIcon.displayName = 'InformationIcon';

export default InformationIcon;
